import { graphql } from '../../../../graphql/generated';

export const CREATE_DIAGNOSE_MUTATION = graphql(`
  mutation CreateDiagnose($input: DiagnoseCreateInput!) {
    createDiagnose(input: $input) {
      id
    }
  }
`);
